import { useQuery } from '@apollo/client';
import type { CommunityPrompt } from '@communities/prompt-management/domain';
import { GET_COMMUNITY_PROMPTS } from '@communities/prompt-management/graphql';
import { transformErrors } from '@core/adapters/errors';
import { EXTENDED_GRAPHQL_TIMEOUT_MS } from '@core/services/constants';
import { useMemo } from 'react';

export interface CommunityPromptsResponse {
  communityPrompts: CommunityPrompt | null;
}

export function useCommunityPrompts(communityId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityPromptsResponse>(GET_COMMUNITY_PROMPTS, {
    variables: { communityId },
    fetchPolicy: 'cache-first',
    skip: !communityId,
    context: { timeout: EXTENDED_GRAPHQL_TIMEOUT_MS },
  });

  const promptData: CommunityPrompt | null = useMemo(() => data?.communityPrompts || null, [data]);

  const errors = useMemo(() => {
    if (!error) return undefined;

    return transformErrors(error);
  }, [error]);

  return {
    promptData,
    rawData: data?.communityPrompts,
    loading,
    errors,
    refetch,
  };
}
